import { render, staticRenderFns } from "./AuthContainer.vue?vue&type=template&id=d20c49b4"
import script from "./AuthContainer.vue?vue&type=script&lang=js"
export * from "./AuthContainer.vue?vue&type=script&lang=js"
import style0 from "./AuthContainer.vue?vue&type=style&index=0&id=d20c49b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports